module.exports = __webpack_public_path__ + "static/media/icon7.e3635e1e.png";